/**
 * Extracts the slug from a permalink URL
 * @param {string} permalink - The permalink URL to extract the slug from
 * @returns {string | undefined} The extracted slug or undefined if permalink is empty
 */
export function getSlugFromPermalink(permalink: string) {
  if (!permalink) {
    return
  }
  // eslint-disable-next-line consistent-return
  return permalink.split('/').pop()
}
